export const flexColumn = `
display:flex;
flex-direction:column;
`;
